/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { StringExtensions } from '@msdyn365-commerce-modules/retail-actions';
import {
    getTelemetryObject,
    Heading,
    IComponentNodeProps,
    INodeProps,
    ISingleSlideCarouselProps,
    ITelemetryContent,
    NodeTag,
    SingleSlideCarousel
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IMttTileListProps, ITitleData } from './mtt-tile-list.props.autogenerated';

/**
 * Tile-list view props.
 */
export interface ITileListViewProps extends IMttTileListProps<{}> {
    title?: React.ReactNode;
    tiles: React.ReactNode[];
    tileItemContainer: INodeProps;
    tileListContainer: INodeProps;
    tileListHeading: INodeProps;
    singleSlideCarouselComponentProps: INodeProps;
}

/**
 *
 * TileList component.
 * @extends {React.PureComponent<IMttTileListProps<{}>>}
 */
export class TileList extends React.PureComponent<IMttTileListProps<{}>> {
    private readonly _telemetryContent: ITelemetryContent = getTelemetryObject(
        this.props.context.request.telemetryPageName!,
        this.props.friendlyName,
        this.props.telemetry
    );
    private static _createHeading(heading?: ITitleData): React.ReactNode | null {
        if (!heading || !heading.text || StringExtensions.isNullOrWhitespace(heading.text)) {
            return null;
        }
        return <Heading headingTag={heading.tag} text={heading.text} className='ms-tile-list__title' />;
    }
    public constructor(props: IMttTileListProps<{}>) {
        super(props);
    }

    public render(): JSX.Element | null {
        const { resources } = this.props;
        const { title, className } = this.props.config;
        const propsCarousel: IComponentNodeProps<ISingleSlideCarouselProps> = {
            tag: SingleSlideCarousel,
            className: this.props.config.className ?? '',
            flipperPrevLabel: resources.flipperPrevious,
            flipperNextLabel: resources.flipperNext,
            parentId: this.props.id,
            telemetryContent: this._telemetryContent,
            vertical: false
        };

        const viewProps = {
            ...this.props,
            title: TileList._createHeading(title),
            singleSlideCarouselComponentProps: propsCarousel,
            tileItemContainer: {
                tag: 'li' as NodeTag,
                className: 'ms-tile__item',
                role: 'listitem'
            },
            tileListContainer: { className: classnames('ms-tile-list', className) },
            tileListHeading: { className: 'ms-tile-list__heading' },
            tiles: this.props.slots.content
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default TileList;
